import gql from 'graphql-tag'

/**
 * 查询用户资产总览
 */

export const queryFundAssetAllInfo = gql`
  query FundAssetAllInfoAndEnquireCurrency ($filter: EnquireAssetAllInput!) {
    FundAssetAllInfo: FundAssetAllInfoNew2(filter: $filter) {
      ok
      reason {
        err
        desc
      }
      data {
        clientId
        fundAccount
        assetHkd
        assetHkdDispaly
        childs {
          type
          assetHkd
          assetHkdRate
          assetHkdDispaly
          assetHkdRateDispaly
        }
      }
    }
    EnquireCurrency: EnquireCurrency {
      ok
      reason {
        err
        desc
      }
      data {
        ccy
        baseCcy
        rate
      }
    } 
  }
`

// 查询汇率
export const queryEnquireCurrency = gql`
  query queryEnquireCurrency {
    EnquireCurrency: EnquireCurrency {
      ok
      reason {
        err
        desc
      }
      data {
        ccy
        baseCcy
        rate
      }
    }
  }
`
// 查询用户资产总览和股票持仓
export const queryFundAccMarketListAndStockPosPageList = gql`
  query stockDataList ($stockPage: FilterGetStockPosPageListInput!, $fundAcc: FilterFundAccMarketListInput) {
    stockPosPageList: StockPosPageList(filter: $stockPage) {
      data {
        rows {
          exchangeType
          stockCode
          stockNameGb
          clientId
          fundAccount
          moneyType
          stockType
          incomeBalanceDisplay
          enableAmountDisplay
          enableAmount
          stockName
          marketValueDisplay
          currentPriceDisplay
          incomePercentDisplay
          costPriceDisplay
          currentAmountDisplay
        }
      }
      ok
      reason {
        err
        desc
      }
    } 
    fundAccMarketList: FundAccMarketList(filter: $fundAcc) {
      data {
        fundAccount
        moneyType
        exchangeType
        marketValueDisplay
        fetchBalanceDisplay
        frozenBalanceDisplay
        enableBalanceDisplay
      }
      ok
      reason {
        err
        desc
      }
    } 
  }
`

// 查询股票资金信息
export const queryFundAccMarketList = gql`
  query queryFundAccMarketList($filter: FilterFundAccMarketListInput) {
    fundAccMarketList: FundAccMarketList(filter: $filter) {
      data {
        fundAccount
        moneyType
        exchangeType
        marketValueDisplay
        fetchBalanceDisplay
        frozenBalanceDisplay
        enableBalanceDisplay
      }
      ok
      reason {
        err
        desc
      }
    }
  }
`

// 查询其他持仓
export const queryOtherPosPageList = gql`
  query queryOtherPosPageList ($filter: FilterGetStockPosPageListInput!) {
    otherPosPageList: OtherPosPageList (filter: $filter) {
      data {
        mv {
          ccy
          value
        } 
        statisInfo {
          exchangeType
          ccy
          mv
          incomeAcc
          incomeBalance
          holdCash
        } 
        rows {
          moneyType
          stockCode
          stockNameGb
          marketValueDisplay
          exchangeType
          stockCode
          underlying
          marketValueDisplay
          maturity_date
          currentAmount
          maturity_days
          yield_to_maturity
        }
      }
      ok
      reason {
        err
        desc
      }
    } 
  }
`
// 查询结构化票据持仓
export const querySpsPageList = gql`
  query querySpsPageList ($stockPos: FilterGetStockPosPageListInput!, $lifecycle: GetClientLifecycleInput!) {
    otherPosPageList: OtherPosPageList (filter: $stockPos) {
      data {
        rows {
          exchangeType
          stockCode
          marketValueDisplay
          investment_amount
          underlying
          issuer
          maturity_date
          sub_type
          moneyType
          yield_to_maturity
        }
        totalMv {
          ccy
          value
        } 
      }
      ok
      reason {
        err
        desc
      }
    }
    clientLifecycle: getClientLifecycle (filter: $lifecycle) {
      ok
      data {
        lifecycles {
          couponRatio
          lifecycleId
          productType
          isin
          size
          underlyingPerformance {
            code
            performance
          } 
        }
      }
      reason {
        err
        desc
      }
    } 
  }
`
// 查询用户资产总览和其他持仓
export const FundAssetAllInfoAndOtherPosPageList = gql`
  query FundAssetAllInfoAndOtherPosPageList ($filter: EnquireAssetAllInput!, $filterOther: FilterGetStockPosPageListInput!) {
    extraFundAssetAllInfo: FundAssetAllInfoNew2(filter: $filter) {
      ok
      reason {
        err
        desc
      }
      data {
        clientId
        fundAccount
        assetHkd
        assetHkdDispaly
        childs {
          type
          assetHkd
          assetHkdRate
          assetHkdDispaly
          assetHkdRateDispaly
        }
      }
    }
    extraPosPageList: OtherPosPageList (filter: $filterOther) {
      data {
        mv {
          ccy
          value
        } 
        statisInfo {
          exchangeType
          ccy
          mv
          incomeAcc
          incomeBalance
          holdCash
        } 
        rows {
          moneyType
          stockCode
          stockNameGb
          stockName
          marketValueDisplay
          marketValueHkdDisplay
          exchangeType
          stockCode
          underlying
          marketValueDisplay
          maturity_date
          currentAmount
          maturity_days
          yield_to_maturity
        }
      }
      ok
      reason {
        err
        desc
      }
    } 
  }
`

export const queryEnquirePositionAll = gql`
  query queryEnquirePositionAll($filter:FilterGetStockPosPageListInput!){
   enquirePositionAll: EnquirePositionAll(filter: $filter) {
      data {
        mv {
          ccy
          value
        } 
        statisInfo {
          exchangeType
          ccy
          mv
          incomeAcc
          incomeBalance
          holdCash
        } 
        totalMv {
          ccy
          value 
        }
        rows {
          moneyType
          stockCode
          stockNameGb
          stockName
          exchangeType
          stockCode
          underlying
          marketValue
          marketValueDisplay
          maturity_date
          currentAmount
          maturity_days
          yield_to_maturity
          enableAmountDisplay
          currentAmountDisplay
          costPriceDisplay
          currentPriceDisplay
          incomeBalanceDisplay
          incomePercentDisplay
          sub_type
          closePrice
          marketValueHkd
          marketValueHkdDisplay
          issuer
        }
      }
      ok
      reason {
        err
        desc
      }
  }
}
`
